import { Flex, Tooltip, Typography } from "antd";
import { getFileIcon } from "utils";
import { TrashCanButton } from "ui";
import fileInputStyles from "../../Inputs/FileInput/fileInput.module.css";

type UploadedFileDisplayProps = {
  fileName: string;
  onRemove: () => void;
  tooltip?: string;
  className?: string;
  showRemoveIcon?: boolean;
};

export const UploadedFileDisplay: React.FC<UploadedFileDisplayProps> = ({
  fileName,
  onRemove,
  tooltip = "Удалить документ",
  className = "",
  showRemoveIcon = true,
}) => {
  return (
    <Flex justify="space-between" className={`${fileInputStyles.uploadedFileWrapper} ${className}`} gap="middle">
      <Flex align="center" gap="small">
        <div className="square bg-basic-200 icon-3xl">{getFileIcon(fileName)}</div>
        <Typography.Text>{fileName}</Typography.Text>
      </Flex>
      {showRemoveIcon && (
        <Tooltip title={tooltip}>
          <TrashCanButton onRemove={onRemove} />
        </Tooltip>
      )}
    </Flex>
  );
};
